<template>
  <div class="verification flex">
    <div>
      <canvas :width="width" :height="height" id="verificationImg" @click="randNumber"></canvas>
      <p class="mark">點擊圖片更新驗證碼</p>
    </div>
    <div class="fill_code">
      <input type="text" v-model="fillCode" class="input_primary"/>
    </div>
  </div>
</template>
<style lang="scss">
.verification{
  canvas{
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 3px 3px 10px -5px rgba(0,0,0,0.5);
    &:hover{
      box-shadow: 1px 1px 1px -1px rgba(0,0,0,0.5);
    }
  }
  .mark{
    margin:5px 0;
    font-size: 12px;
    color: var(--fontGray);
  }
  .fill_code{
    margin-left: 20px;
  }
}
</style>
<script>
export default {
  name: "verification",
  data() {
    return {
      number: 4,
      code: [],
      width:"120",
      height:"40",
      fillCode:null,
    };
  },
  methods: {
    randNumber() {
      //隨機數字
      let rawCode =
        "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,0,1,2,3,4,5,6,7,8,9";
      let code = rawCode.split(",");
      const codeList = [];
      for (let i = 0; i < this.number; i++) {
        const randNnuber = Math.floor(Math.random() * code.length); //取隨機數字
        codeList.push(code[randNnuber]);
      }
      this.code = codeList;
      this.randCanvas();
    },
    randColor() {
      let r = Math.floor(Math.random() * 255);
      let g = Math.floor(Math.random() * 255);
      let b = Math.floor(Math.random() * 255);
      return `rgba(${r},${g},${b},0.9)`
    },
    randCanvas() {
      const mycanvas = document.getElementById("verificationImg");
      const ctx = mycanvas.getContext("2d");
      ctx.clearRect(0, 0, this.width, this.height);
      ctx.font='15pt Arial'
      for (let i = 0; i < this.number; i++) {
        const dx = Math.random() * 10 + 30 * i; //隨機Ｘ軸
        const dy = Math.random() * 5 + this.height / 2; //隨機Ｙ軸
        ctx.fillText(this.code[i], dx, dy);
      }
      
      this.randLine(ctx)
    },
    randLine(ctx){
      for(let i=0; i<this.number+2; i++){
        let dx1 = Math.random()* this.width
        let dy1 = Math.random()* this.height
        let dx2 = Math.random()* this.width
        let dy2 = Math.random()* this.height
        ctx.strokeStyle = this.randColor()
        ctx.beginPath();
        ctx.moveTo(dx1, dy1);
        ctx.lineTo(dx2, dy2);
        ctx.stroke();
      }
      
    },

  },
  mounted() {
    this.randNumber();
  }
};
</script>